import { FilterNestedData } from '../types';

/**
 * Достать информацию о вложеном поле для фильтра из составной строки
 * @param filterNestedData {object}
 */
const getFilterNestedField = (compositeString: string): FilterNestedData | undefined => {
  const startBracketIndex = compositeString.indexOf('[');
  const endBracketIndex = compositeString.lastIndexOf(']');

  const field = compositeString.substring(startBracketIndex + 1, endBracketIndex);
  const [fieldKey, fieldValue = ''] = field.split('=');

  try {
    return {
      key: fieldKey,
      value: JSON.parse(fieldValue),
    };
    // eslint-disable-next-line no-empty
  } catch {}
};

export default getFilterNestedField;
